import React, { Component } from 'react';
import '../../App.scss';
import CreditCard from '../../components/CreditCard/CreditCard';
import ShoppingCart from '../../components/ShoppingCart/ShoppingCart';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import parameterService from '../../services/parameterService';
import languageService from '../../services/languageService'

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customFieldsAreUsed: parameterService.customFieldsAreUsed()
        };

        languageService.onChange(() => {
            this.forceUpdate()
        });
    }

    componentDidMount = () => {
        this.sidebar = document.querySelector('.details-sidebar');
    };

    toggleSideBar = () => {
        this.sidebar.classList.toggle('is-collapsed');
    };


    render() {
        const embed = parameterService.isEmbedMode();
        const leftPanel = (<ShoppingCart/>);
        const rightPanel = (<CreditCard/>);

        return (
            <div className={
                [
                    'app-container',
                    'container-fluid',
                    embed ? 'embed' : '',
                    this.state.customFieldsAreUsed ? " has-custom-fields" : null
                ].join(' ')
            }>
                <Header/>
                <div className={"App container" + (this.state.customFieldsAreUsed ? "": " no-background")}>
                    <div className="row ContentWrapper">
                        {this.state.customFieldsAreUsed && (
                            <div className="details-sidebar">
                                <button className="sidebar-toggle arrow-svg" onClick={this.toggleSideBar}></button>
                                {leftPanel}
                            </div>
                        )}
                        <div className={"page-container col-md-12"}>
                            {rightPanel}
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/CreditCard/AppCC.js